import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SagtoastRoutingModule } from './sagtoast-routing.module';
import { SagtoastComponent } from './sagtoast.component';

@NgModule({
  declarations: [
    SagtoastComponent
  ],
  exports: [SagtoastComponent],
  imports: [
    CommonModule,
    SagtoastRoutingModule
  ]
})
export class SagtoastModule { }
